<template>
  <ul class="secondaryMenuItems">
    <li
      v-for="smi in secondaryMenuItems"
      :key="'secondaryMenuItem-' + smi.name"
      class="menu-right-item"
      :class="['menu-dropdopwn-item-' + smi.id, isActiveMenuItem(smi) && hoveringMenuItem === smi.name && 'menu-item-background-active']"
      @mouseover="hoveringMenuItem = smi.name"
      @mouseleave="hoveringMenuItem = ''"
    >
      <a :href="smi.url" :class="[isActiveMenuItem(smi) && 'menu-item-active']">
        {{ smi.name }}
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'SecondaryMenu',
  props: {
    secondaryMenuItems: {
      type: Array,
      default: () => [],
    },
    routeItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      hoveringMenuItem: '',
    };
  },
  methods: {
    isActiveMenuItem(menuItem) {
      return (
        menuItem &&
        this.routeItem &&
        this.routeItem.name.toLowerCase() === menuItem.name.toLowerCase() &&
        this.routeItem.parentId === menuItem.parentId
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@article/pixel/dist/style/variables';

.secondaryMenuItems {
  position: relative;
  width: 180px;
  left: 200px;
  margin-top: -40px;
  box-shadow: 0 var(--box-shadow-blur) var(--box-shadow-spread) var(--shadow-color);

  .menu-item-active {
    color: var(--coral) !important;
  }

  .menu-item-background-active {
    background-color: var(--coral-light) !important;
  }

  .menu-right-item {
    background-color: var(--white);
    &:first-child {
      border-radius: var(--space-1) var(--space-1) var(--space-0) var(--space-0);
    }
    &:last-child {
      border-radius: var(--space-0) var(--space-0) var(--space-1) var(--space-1);
    }
    &:hover {
      background-color: var(--grey-ultra-light);
    }
    a {
      &:hover {
        color: var(--grey-ultra-dark);
      }
    }
  }
}
</style>
